module.exports = __webpack_public_path__ + "img/tabbar5-1.1b2e7d65.svg";